module.exports = __webpack_public_path__ + "img/62178ab45bcd6fc88296aad92cf3877f.jpg";